import { Icon } from '@frontend/icons';
import { useLocationService } from '@frontend/wam-location-service';
import { theme } from '@frontend/theme';
import { Stepper, Text } from '@frontend/design-system';
import { SimpleInfoOutlinedCard } from '../../components/outlined-card';

export const UnifyDevices = () => {
  const { currentLocation } = useLocationService();
  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        paddingTop: theme.spacing(2),
        gap: theme.spacing(4),
      }}
    >
      <div
        css={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: theme.spacing(3),
        }}
      >
        <SimpleInfoOutlinedCard
          header='Parent Tenant Location ID'
          body={currentLocation?.locationId ?? 'Unknown'}
          canCopyToClipboard={true}
        />
        <SimpleInfoOutlinedCard
          header='Parent Tenant Name'
          body={currentLocation?.name ?? 'Unknown'}
          canCopyToClipboard={true}
        />
      </div>
      <Stepper>
        <Stepper.Card>
          <Stepper.Content>
            <Stepper.Title>Step 1: Copy Media</Stepper.Title>
            <Text color='light' size='medium'>
              This will copy all media files related to voicemail, call recordings, phone trees, and media library to
              the parent PDS tenant. Copying media can be performed multiple times if needed.
            </Text>
            <Text css={{ paddingTop: theme.spacing(2) }} color='light' size='medium'>
              Note: Copying the media files can take minutes depending on media volume.
            </Text>
            <Stepper.ButtonBar>
              <Stepper.NextButton isOptionalStep>Copy Remaining (1) Files</Stepper.NextButton>
            </Stepper.ButtonBar>
          </Stepper.Content>
        </Stepper.Card>
        <Stepper.Card>
          <Stepper.Content>
            <Stepper.Title>
              <div css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
                <Icon name='info-small' />
                <Text>Step 2: Copy Tenant Configuration</Text>
              </div>
            </Stepper.Title>
            <Text color='light' size='medium'>
              This will copy all PDS primitive configuration data from the child tenant to the parent tenant.
              <Text as='span' color='error' size='medium'>
                {' '}
                Warning: This may only be performed once!
              </Text>
            </Text>
            <Text css={{ paddingTop: theme.spacing(2) }} color='light' size='medium'>
              All device MAC addresses and phone numbers will be stubbed on the parent tenant to keep from interrupting
              call routing. To initiate call routing to the parent account the stubbed devices and phone numbers must be
              updated to be the actual MAC addresses and phone numbers. Devices will need to receive new configuration
              which can be accomplished by a resync.
            </Text>
            <Stepper.ButtonBar>
              <Stepper.NextButton isValid>Copy Remaining (1) Files</Stepper.NextButton>
            </Stepper.ButtonBar>
          </Stepper.Content>
        </Stepper.Card>
      </Stepper>
    </div>
  );
};
